import { request, apiHeaders } from "./base";
import { TabAccess } from "../../contexts/TabAccessContext";

export const getTabs = (): Promise<TabAccess> => request("/tab-access").then((res) => res.json()).then(({ data }) => data );